function t(t){return t.split("-")[1]}export{t as default};
